import { render, staticRenderFns } from "./partnerize-tracking.vue?vue&type=template&id=5ca2e8e1"
import script from "./partnerize-tracking.vue?vue&type=script&lang=ts&setup=true"
export * from "./partnerize-tracking.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports